import {
  Badge,
  Button,
  Card,
  Col,
  Divider,
  message,
  Row,
  Typography,
} from "antd";
import classes from "./integrations.module.scss";

import { useState } from "react";
import IntegrationModal from "./IntegrationModal";
import { accountingSoftware, bankingAPIs } from "./constant";
import classNames from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../constants";
import { fetchAppIntegrationUrls } from "../../services/integrations";
import Loader from "../../components/Loading";
import { useDispatch, useSelector } from "react-redux";
import { connectQuickBooks } from "../../services/quickbooks";
import { updateUserProfileAction } from "../../redux/action";
import { connectFreshBooks } from "../../services/freshbook";
import ErpIntegrations from "../ErpIntegrations";

const { Title, Text } = Typography;

const Integrations = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const appToConnect = params.get("app");

  const urlCode = params.get("code");
  const quickBooksStateAfterAppConnect = params.get("state");
  const quickBooksRealmIdAfterAppConnect = params.get("realmId");

  const userProfile = useSelector((state) => state.userProfile);

  const [isOpen, setIsOpen] = useState(false);
  const [integratedAppsList, setIntegratedAppsList] = useState({
    accountingSoftware,
    bankingAPIs,
  });
  const [selectedApp, setSelectedApp] = useState({});

  const getAppIntegrationUrlsQuery = useQuery({
    queryKey: [queryKeys.appUrls],
    queryFn: () => fetchAppIntegrationUrls(),
  });

  const connectQuickbooksQuery = useQuery({
    queryKey: [queryKeys.connectQuickbooks],
    queryFn: () =>
      connectQuickBooks({
        code: urlCode,
        state: quickBooksStateAfterAppConnect,
        realmId: quickBooksRealmIdAfterAppConnect,
      }),
    enabled:
      Boolean(urlCode) &&
      Boolean(quickBooksStateAfterAppConnect) &&
      Boolean(quickBooksRealmIdAfterAppConnect),
  });

  const connectFreshbooksQuery = useQuery({
    queryKey: [queryKeys.connectFreshBooks],
    queryFn: () =>
      connectFreshBooks({
        code: urlCode,
      }),
    enabled:
      Boolean(urlCode) && Boolean(appToConnect) && appToConnect === "freshbook",
  });

  const handleClose = () => {
    setIsOpen(false);
    setSelectedApp({});
  };

  const handleOpen = (item) => {
    setIsOpen(true);
    setSelectedApp(item);
  };

  const updateAccountingSoftware = (data) => {
    const updatedAppsList = integratedAppsList.accountingSoftware.map((item) =>
      item.id === data.id ? data : item
    );
    setIntegratedAppsList({
      ...integratedAppsList,
      accountingSoftware: updatedAppsList,
    });
  };

  const updateBankingAPIs = (data) => {
    const updatedAppsList = integratedAppsList.bankingAPIs.map((item) =>
      item.id === data.id ? data : item
    );
    setIntegratedAppsList({
      ...integratedAppsList,
      bankingAPIs: updatedAppsList,
    });
  };

  const handleConnect = (data) => {
    switch (data.key) {
      case "accountingSoftware":
        updateAccountingSoftware(data);
        break;
      case "bankingAPIs":
        updateBankingAPIs(data);
        break;
      default:
        break;
    }
  };

  const getAppIntegrationStatus = (item) => {
    switch (item.title) {
      case "Asana":
        return {
          connected: Boolean(userProfile?.is_connected_asana),
          status: Boolean(userProfile?.is_connected_asana)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_asana)
            ? "#4CAF50"
            : "#03A9F4",
        };
      case "QuickBooks":
        return {
          connected: Boolean(userProfile?.is_connected_quickbook),
          status: Boolean(userProfile?.is_connected_quickbook)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_quickbook)
            ? "#4CAF50"
            : "#03A9F4",
        };

      case "FreshBooks":
        return {
          connected: Boolean(userProfile?.is_connected_freshbook),
          status: Boolean(userProfile?.is_connected_freshbook)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_freshbook)
            ? "#4CAF50"
            : "#03A9F4",
        };
        case "Salesforce":
        return {
          connected: Boolean(userProfile?.is_connected_salesforce),
          status: Boolean(userProfile?.is_connected_salesforce)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_salesforce)
            ? "#4CAF50"
            : "#03A9F4",
        };
        case "Clearbit":
        return {
          connected: Boolean(userProfile?.is_connected_clearbit),
          status: Boolean(userProfile?.is_connected_clearbit)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_clearbit)
            ? "#4CAF50"
            : "#03A9F4",
        };
        case "GoogleSheets":
        return {
          connected: Boolean(userProfile?.is_connected_google_sheets),
          status: Boolean(userProfile?.is_connected_google_sheets)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_google_sheets)
            ? "#4CAF50"
            : "#03A9F4",
        };
        case "Intercom":
        return {
          connected: Boolean(userProfile?.is_connected_intercom),
          status: Boolean(userProfile?.is_connected_intercom)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_intercom)
            ? "#4CAF50"
            : "#03A9F4",
        };
        case "Mixpanel":
        return {
          connected: Boolean(userProfile?.is_connected_mixpanel),
          status: Boolean(userProfile?.is_connected_mixpanel)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_mixpanel)
            ? "#4CAF50"
            : "#03A9F4",
        };
        case "Slack":
        return {
          connected: Boolean(userProfile?.is_connected_slack),
          status: Boolean(userProfile?.is_connected_slack)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_slack)
            ? "#4CAF50"
            : "#03A9F4",
        };
        case "Stripe":
        return {
          connected: Boolean(userProfile?.is_connected_stripe),
          status: Boolean(userProfile?.is_connected_stripe)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_stripe)
            ? "#4CAF50"
            : "#03A9F4",
        };
        case "Intercom":
        return {
          connected: Boolean(userProfile?.is_connected_intercom),
          status: Boolean(userProfile?.is_connected_intercom)
            ? "Connected"
            : "Ready",
          statusColor: Boolean(userProfile?.is_connected_intercom)
            ? "#4CAF50"
            : "#03A9F4",
        };
      default:
        return {
          connected: false,
          status: item.status,
          statusColor: item.statusColor,
        };
    }
  };

  const handleConnectApp = (item) => {
    const { quickbook_url, asana_url, freshbook_url, slack_url, google_sheets_url, mixpanel_url, clearbit_url, stripe_url, salesforce_url,intercom_url } =
      getAppIntegrationUrlsQuery.data?.data;
    switch (item.title) {
      case "Salesforce":
        window.location.href = salesforce_url;
      break;
      case "Asana":
        window.location.href = asana_url;
        break;
      case "QuickBooks":
        window.location.href = quickbook_url;
        break;
      case "FreshBooks":
        window.location.href = freshbook_url;
        break;
      case "Slack":
        window.location.href = slack_url;
      break;
      case "Google Sheets":
        window.location.href = google_sheets_url;
      break;
      case "Mixpanel":
        window.location.href = mixpanel_url;
      break;
      case "Clearbit":
        window.location.href = clearbit_url;
      break;
      case "Stripe":
        window.location.href = stripe_url;
      break;
      case "Intercom":
        window.location.href = intercom_url;
      break;
      default:
        break;
    }
  };

  if (
    (connectQuickbooksQuery.error &&
      urlCode &&
      quickBooksStateAfterAppConnect &&
      quickBooksRealmIdAfterAppConnect) ||
    (connectFreshbooksQuery.error &&
      urlCode &&
      appToConnect &&
      appToConnect === "freshbook")
  ) {
    navigate("/home/integrations");
    message.error("Failed to connect Integration. Please try again.");
  }

  if (connectQuickbooksQuery.isSuccess && urlCode) {
    navigate("/home/integrations");
    dispatch(
      updateUserProfileAction({ ...userProfile, is_connected_quickbook: true })
    );
  }
  if (
    connectFreshbooksQuery.isSuccess &&
    urlCode &&
    appToConnect === "freshbook"
  ) {
    navigate("/home/integrations");
    dispatch(
      updateUserProfileAction({ ...userProfile, is_connected_freshbook: true })
    );
  }

  return getAppIntegrationUrlsQuery.isLoading ? (
    <Loader />
  ) : (
    <>
      {/* <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          Integrations
        </Title>
      </div> */}
      <div className={classes.headerContent}>
        <div className={classes.header}>
          <Title level={4} style={{ marginTop: 0 }}>
          Connect Your Stack
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Choose the tools you want Radar+ to sync with. For maximum accuracy, please connect all
tools available.
        </Text>
        </div>
      </div>
      <Row marginTop={20} gutter={[16, 16]}>
        {integratedAppsList.accountingSoftware.map((item, index) => {
          const appStatus = getAppIntegrationStatus(item);
          const { connected, status, statusColor } = appStatus;
          return (
            <Col span={8} key={index}>
              <Badge.Ribbon text={status} color={statusColor}>
                <div
                  className={classNames({
                    [classes.cardCnt]: true,
                  })}
                >
                  <Card hoverable bordered className={classes.customCard}>
                    <div className={classes.cardHeader}>
                      <div className={classes.graphHeader}>
                        <div>
                          <img src={item.image} height={item.height} alt="qb" />
                        </div>
                        <span className={classes.title}>{item.title}</span>
                        <span className={classes.subTitle}>
                          {item.description}
                        </span>
                      </div>
                    </div>
                  </Card>
                  {connected ? (
                    <div className={classes.wrapperContainer}>
                      <Button
                        type="primary"
                        onClick={() => item.pageUrl && navigate(item.pageUrl)}
                      >
                        Go to Dashboard
                      </Button>
                    </div>
                  ) : (
                    <div className={classes.wrapperContainer}>
                      <Button
                        type="primary"
                        onClick={() => handleConnectApp(item)}
                      >
                        Connect
                      </Button>
                    </div>
                  )}
                </div>
              </Badge.Ribbon>
            </Col>
          );
        })}
      </Row>
      <Divider />
      <div className={classes.headerContent}>
        <span className={classes.selectSector}>Banking APIs</span>
      </div>
      <Row marginTop={20} gutter={[16, 16]}>
        {integratedAppsList.bankingAPIs.map((item, index) => (
          <Col span={8} key={index}>
            <Badge.Ribbon text={item.status} color={item.statusColor}>
              <div
                className={classNames({
                  [classes.cardCnt]: item.status === "Connected",
                })}
              >
                <Card
                  hoverable
                  bordered
                  className={classes.customCard}
                  onClick={() => handleOpen(item)}
                >
                  <div className={classes.cardHeader}>
                    <div className={classes.graphHeader}>
                      <div>
                        <img src={item.image} height={30} alt="qb" />
                      </div>
                      <span className={classes.title}>{item.title}</span>
                      <span className={classes.subTitle}>
                        {item.description}
                      </span>
                    </div>
                  </div>
                </Card>
                {item.status === "Connected" && (
                  <div className={classes.wrapperContainer}>
                    <Button
                      type="primary"
                      onClick={() =>
                        navigate(`/home/integrated-app-dashboard/${item.id}`)
                      }
                    >
                      Go to dashboard
                    </Button>
                  </div>
                )}
              </div>
            </Badge.Ribbon>
          </Col>
        ))}
      </Row>
      <Divider />
      <div className={classes.headerContent}>
        <span className={classes.selectSector}>ERP Software</span>
      </div>
      <ErpIntegrations />

      {isOpen && (
        <IntegrationModal
          isOpen={isOpen}
          onClose={handleClose}
          selectedApp={selectedApp}
          handleConnectApp={handleConnect}
        />
      )}
    </>
  );
};
export default Integrations;
